import { createBrowserRouter } from "react-router-dom";

import App from "./App";
import Home from "./pages/Home";
import Register from './pages/Register';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Questionnaire from "./pages/Questionnaire";
import PromptPage from "./pages/PromptPage";
import CreateArtworkModal from "./components/CreateArtworkModal";
import CanvasPage from './components/NewCanvas/CanvasPage';
import ArtDetail from "./pages/ArtDetail";
import Portfolio from "./pages/Portfolio";
import Profile from './pages/Profile';
import Error from "./pages/Error";
import PasswordResetRequest from "./pages/PasswordResetRequest";
import PasswordReset from "./pages/PasswordReset";



const routes = [
    {
      path: '/',
      element: <App />,
      errorElement: <Error />,
      children: [
        { 
          path: "/",
          index: true, 
          element: <Home />
        },
        { 
          path: '/register', 
          element: <Register /> 
        },
        { 
          path: '/login', 
          element: <Login /> 
        },
        { 
          path: '/reset-password', 
          element: <PasswordResetRequest /> 
        },
        { 
          path: '/reset-password/:token', 
          element: <PasswordReset /> 
        },
        { 
          path: '/questionnaire', 
          element: <ProtectedRoute><Questionnaire /></ProtectedRoute>
        },
        { 
          path: '/prompts', 
          element: <ProtectedRoute><PromptPage /></ProtectedRoute>
        },
        { 
          path: '/artwork/:art_id', 
          element: <ProtectedRoute><ArtDetail /></ProtectedRoute>
        },
        { 
          path: '/portfolio', 
          element: <ProtectedRoute><Portfolio /></ProtectedRoute>
        },
        { 
          path: '/profile', 
          element: <ProtectedRoute><Profile /></ProtectedRoute>
        },

        // Dynamic Prompt Routes
        { 
          path: '/prompt/:promptId/artwork', 
          element: <ProtectedRoute><CreateArtworkModal /></ProtectedRoute>
        }, 
        { 
          path: '/prompt/:promptId/canvas', 
          element: <ProtectedRoute><CanvasPage /></ProtectedRoute>
        },
      ]
    }
  ];
  
export const router = createBrowserRouter(routes)